import { createContext } from "react";
import type { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import type { useActorToneColors } from "@-/dev.improve.haniverse.routes.nav.app._lib.actor.user";
import type { useGetGraphemeGlyph } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.glyph/client";
import type { useGetGraphemePrevalence } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.prevalence";

export type MorphemeTilePresentation = {
  fadeMissingMnemonicEnabled: boolean;
  getGraphemeGlyph: ReturnType<typeof useGetGraphemeGlyph>;
  getGraphemePrevalence: ReturnType<typeof useGetGraphemePrevalence>;
  isToneColorsEnabled: boolean;
  svgTileGlyphsEnabled: boolean;
  toneColors: ReturnType<typeof useActorToneColors>;
  user: ReturnType<typeof useActorUser>;
};

export const MorphemeTilePresentationContext = createContext<MorphemeTilePresentation | null>(null);
